<template>
  <div id="ht-app" class="d-flex">
    <main-bar-menu-v2/>
    <div class="header-top">
      <div class="container-fluid">
        <heading-user />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <header-v2 :title="headerTitle"/>
      <b-container fluid>
        <slot name="container">
        </slot>
      </b-container>
    </div>
  </div>
</template>

<script>

export default {
  name: 'layoutHealthTrackerV2App',
  components: {
    MainBarMenuV2: () => import('@/components/layouts/MainBarMenuV2.vue'),
    HeadingUser: () => import('@/components/user/HeadingUser.vue'),
    HeaderV2: () => import('@/components/common/header/HeaderV2.vue')
  }
  , props : {
    headerTitle: String
  }
}
</script>

<style scoped />